import type { SVGProps } from "react";
export interface AuthentikLogoIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AuthentikLogoIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AuthentikLogoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill="#FD4B2D"
        d="M13.632 7.256h-.7v2.057h.7zM15.453 7.17h-.7v1.608h.7zM4.553 9.519c-.46 0-.91.128-1.305.37-.395.243-.719.59-.937 1.006h1.188c.525-.466 1.288-.602 1.84 0h1.256c-.49-.682-1.228-1.376-2.042-1.376M6.248 12.137c-1.637 3.52-4.506.518-2.752-1.242H2.31c-.931 1.67.356 3.92 2.243 3.87 1.459 0 2.664-2.229 2.664-2.623 0-.173-.236-.707-.624-1.247H5.336c.417.39.78.956.912 1.242"
      />
      <path
        fill="#FD4B2D"
        d="M22 7.231v9.296a3.28 3.28 0 0 1-.922 2.284 3.1 3.1 0 0 1-2.22.947h-1.333v-3.165h-6.367v3.165H9.825a3.1 3.1 0 0 1-2.22-.947 3.28 3.28 0 0 1-.921-2.284v-2.923h10.095V8.013h-4.875v3.14h-5.22V7.232q0-.187.021-.37a3.3 3.3 0 0 1 .126-.607l.02-.066.024-.066.027-.074.03-.073q.117-.286.285-.545l.004-.005a3 3 0 0 1 .165-.23c.026-.033.062-.075.094-.112l.095-.105.004-.003.053-.055q.175-.175.373-.321.054-.04.11-.078l.127-.08a4 4 0 0 1 .336-.176 3 3 0 0 1 .585-.193q.21-.047.425-.064l.063-.004h.03q.07-.003.144-.003h9.033q.072 0 .143.003h.03l.063.004a3.1 3.1 0 0 1 1.01.257l.084.039a3 3 0 0 1 .489.295 3.2 3.2 0 0 1 .525.484q.047.056.094.113c.031.038.052.067.078.102l.088.127.004.005q.167.259.285.545l.03.073q.014.036.027.074l.023.066.021.066.01.034q.021.066.038.137a3.3 3.3 0 0 1 .1.806"
      />
      <path
        fill="#FD4B2D"
        d="M21.465 5.43H7.22c.287-.44.675-.8 1.129-1.05A3.1 3.1 0 0 1 9.824 4h9.036a3.1 3.1 0 0 1 1.476.38c.454.25.842.61 1.13 1.05M21.978 6.86H6.703a3.25 3.25 0 0 1 .514-1.43h14.246c.281.427.458.918.515 1.43"
      />
      <path
        fill="#FD4B2D"
        d="M22 7.23v1.06h-5.221v-.277h-4.875v.278H6.683V7.23q0-.186.02-.371H21.98q.021.185.02.37"
      />
      <path
        fill="#FD4B2D"
        d="M11.905 8.29H6.683v1.431h5.222zM22 8.29h-5.223v1.431h5.222zM11.905 9.722H6.683v1.43h5.222zM22 9.722h-5.223v1.43h5.222z"
      />
    </svg>
  );
}
